<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWIRCODES')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('NAME')">
                <inputvalidation :formerror="formError" name="name">
                  <select class="form-control" name="moduleId" v-model="learningModuleId">
                    <option value="">{{$t('SELECTLEARNINGMODULE')}}</option>
                    <option v-for="item in modulesData.root" :value="item.moduleId">{{item.moduleName}}</option>
                  </select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row" v-if="learningModuleId != ''">
            <div class="col-sm-12">
              <label></label>
              <button class="btn btn-primary" v-on:click.prevent="startLearing">{{$t('STARTLEARNING')}}</button>
            </div>
          </div>
          <div class="row" v-if="startedLearning">
            <div class="col-sm-12">
              <label></label>
              <p>{{$t('STARTLEARNINGDISCLAIMER')}}</p>
              <b-progress :max="20" animated><b-progress-bar :value="learningSeconds" >{{ learningSeconds }} / 20</b-progress-bar></b-progress>
            </div>
          </div>
          <div v-if="formData.code != '' && startInt == 2">
            <div class="row">
              <div class="col-sm-12">
                <b-form-fieldset v-bind:label="$t('NAME')">
                  <inputvalidation :formerror="formError" name="name"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
                </b-form-fieldset>
              </div>
            </div>
            <div slot="footer">
              <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
              <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(formData)"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
            </div>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> {{$t('IRCODES')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <select class="form-control" name="moduleId" v-model="testingModuleId">
                      <option value="">{{$t('SELECTTESTINGMODULE')}}</option>
                      <option v-for="item in modulesData.root" :value="item.moduleId">{{item.moduleName}}</option>
                    </select>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('NAME')}}</th>
                    <th v-if="testingModuleId != ''">{{$t('TEST')}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data.root">
                    <td>{{item.irCodeId}}</td>
                    <td><b-form-input type="text" v-model="item.name"></b-form-input></td>
                    <td v-if="testingModuleId != ''"><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="sendCode(item)"><icon name="save"></icon> {{$t('TEST')}}</b-button></td>
                    <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="saveRow(item)"><icon name="save"></icon> {{$t('SAVE')}}</b-button></td>
                    <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.irCodeId)"><icon name="ban"></icon> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import Api from '@/api/IrCodes';
import ModulesApi from '@/api/Modules';

export default {
    name: 'IrCodes',
    data()
    {
        const me = this;
        return {
            data: {},
            learningModuleId: '',
            testingModuleId: '',
            learningSeconds: 0,
            startedLearning: false,
            startInt: 1,
            formError: {},
            modulesData: {},
            formData: {
                id: '', irDeviceId: '', name: '', code: '',
            },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 20,
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;
        me.formData.irDeviceId = me.$route.params.irDeviceId;
        me.getData();
        me.getModulesData();
    },
    methods:
  {
      startLearing()
      {
          const me = this;

          me.startedLearning = true;

          var interval = setInterval(() =>
          {
              me.learningSeconds++;
              if (me.learningSeconds == 20)
              {
                  clearInterval(interval);
                  me.learningSeconds = 0;
                  me.startedLearning = false;
              }
          }, 1000);

          me.startInt = 1;
          me.formData.code = '';
          me.socket.on('message', (message) =>
          {
              if (message.topic == 'ircode')
              {
                  if (me.startInt == 2)
                  {
                      clearInterval(interval);
                      me.startedLearning = false;
                  }
                  else
                  {
                      me.startInt = 2;
                  }

                  me.formData.code += message.message;
              }
          });

          Api.startIrLearn({ moduleId: me.learningModuleId }, function (val)
          {
              if (val.error)
              {
                  me.$notify.notice(val);
                  me.formError = val;
              }
              else
              {
                  me.$notify.notice(val);
                  me.formError = {};
                  me.getData();
              }
          });
      },
      sendCode(item)
      {
          const me = this;
          item.moduleId = me.testingModuleId;
          Api.sendCode(item, function (val)
          {
              if (val.error)
              {
                  me.$notify.notice(val);
                  me.formError = val;
              }
              else
              {
                  me.$notify.notice(val);
                  me.formError = {};
                  me.getData();
              }
          });
      },
      getModulesData()
      {
          const me = this;
          ModulesApi.selectRow(me.getParams, function (data)
          {
              if (data.error && data.error == true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.modulesData = data;
          });
      },
      saveRow(item)
      {
          const me = this;

          if (typeof item.irCodeId !== 'undefined')
          {
              item.id = item.irCodeId;
              delete (item.irCodeId);
          }

          Api.save(item, function (val)
          {
              if (val.error)
              {
                  me.$notify.notice(val);
                  me.formError = val;
              }
              else
              {
                  me.$notify.notice(val);
                  me.formError = {};
                  me.getData();
              }
          });
      },
      getData()
      {
          const me = this;
          Api.selectRow(me.getParams, function (data)
          {
              if (data.error && data.error == true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.data = data;
          });
      },
      deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  btnAction()
                  {
                      Api.deleteRow({ id }, function (data)
                      {
                          me.$notify.notice(data);
                          me.getData();
                      });
                  },
              });
      },
  },
    watch:
  {
      'pagination.currentPage'(val)
      {
          const me = this;
          me.getData();
      },
      'pagination.query'(val)
      {
          const me = this;

          if (me.pagination.searchTimeout != false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(function ()
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
          'socket',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.irDeviceId = me.formData.irDeviceId;
          return data;
      },
  },
};
</script>
